import routerOptions0 from "/usr/src/app/node_modules/.pnpm/nuxt@4.3.0_@parcel+watcher@2.5.6_@types+node@25.0.10_@vue+compiler-sfc@3.5.27_cac@6.7.1_50b90316ccb8415fd4b40a76ed323eca/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}